import { gql } from "@apollo/client";

export const GET_ULTIMO_CODIGO_INSTITUCION = gql`
query QUltimoCodigoInstitucionNH {
    ultimoCodigoInstitucionNH
        {
            success,
            error,
            valorEsperado 
        }
}`;